import { render, staticRenderFns } from "./UsersShow.vue?vue&type=template&id=4df1fbe4&"
import script from "./UsersShow.vue?vue&type=script&lang=js&"
export * from "./UsersShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports